import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '../../api/models';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { SolicitacaoRenovacaoService, InstituicaoEnsinoService, EnumService, CursoService, InstituicaoGestoraService } from '../../api/services';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Pagination } from '@app/shared/model';
import { DialogModule } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { TableColumn, TableComponent } from '@app/shared/components/table/table.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-home-renovacao',
  imports: [
    SearchBarComponent,
    BackButtonComponent,
    CommonModule,
    ButtonModule,
    TagModule,
    ReactiveFormsModule,
    TableComponent,
    DialogModule,
    InputText,
    DataVoidComponent,
    SelectModule,
    Toast
  ],
  providers: [
    MessageService,
    InstituicaoEnsinoService,
    EnumService,
    CursoService,
    InstituicaoGestoraService
  ],
  templateUrl: './home-renovacao.component.html',
  styleUrl: './home-renovacao.component.scss'
})
export class HomeRenovacaoComponent implements OnInit {
  solicitacoesCount: any;
  form!: FormGroup;
  constructor(private router: Router, private fb: FormBuilder) { }

  solicitacaoRenovacao = inject(SolicitacaoRenovacaoService);
  messageService = inject(MessageService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  instituicaoGestoraService = inject(InstituicaoGestoraService);
  enumService = inject(EnumService);
  cursoService = inject(CursoService);
  pagination: Pagination<any> = new Pagination<any>();
  solicitacaoRenovacaoList: any[] = [];
  estadoBolsaOptions: any[] = [];
  estadoSolicitaOptions: any[] = [];
  instituicaoEnsinoList: any[] = [];
  instituicaoGestoraList: any[] = [];
  cursoList: any[] = [];
  NivelAcademicoOptions: any[] = [];
  showFilter: boolean = false;

  actions = [
    {
      label: 'Dar Parecer',
      icon: 'pi pi-pencil',
      command: ($event: any) => {
        console.log('Menu action data:', $event.item.data);
        this.GotoViewProcess($event.item.data);
      },
    },
  ];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'InstituicaoEnsinoID',
      placeholder: 'Instituição de ensino',
      optionLabel: 'label',
      options: this.instituicaoEnsinoList,
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'InstituicaoGestoraID',
      placeholder: 'Instituição Gestora',
      optionLabel: 'label',
      options: this.instituicaoGestoraList,
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'cursoID',
      placeholder: 'Curso',
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'nivelAcademicoID',
      placeholder: 'Nível Académico',
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoBolsaID',
      placeholder: 'Estado da Bolsa',
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'Estado',
      placeholder: 'Estado da Solicitação',
      optionLabel: 'label',
      optionValue: 'id',
    },
  ];

  columns: TableColumn[] = [
    { field: 'Bolsa.bolseiro.nome', header: 'Estudante' },
    // { field: 'Nacionalidade', header: 'Nacionalidade', type: 'text', tooltip: 'Nacionalidade' },
    { field: 'Bolsa.pais.designacao', header: 'País de Estudo', type: 'text', tooltip: 'País de Estudo' },
    {
      field: 'ParecerEstudanteDescricao',
      header: 'Parecer Estudante',
      type: 'tag',
      tagSeverityFunction: (rowData: any) =>
        this.getSeverity(rowData.ParecerEstudanteDescricao),
      tooltip: 'Parecer do Estudante',
    },
    { field: 'ParecerInstituicaoDescricao', header: 'Parecer Representante', type: 'text', tooltip: 'Parecer Representante' },
    {
      field: 'ParecerMIREMPETDescricao',
      header: 'Parecer MIREMPET',
      type: 'text',
      tooltip: 'Parecer MIREMPET'
    },
    {field: 'AnoLetivoAnterior.ano', header: 'Ano Lectivo Anterior', type: 'text', tooltip: 'Ano lectivo anterior'},
    {field: 'AnoLetivoAtivacao.ano', header: 'Ano Lectivo Activação', type: 'text', tooltip: 'Ano lectivo Activação'},
    {
      field: 'EstadoDescricao',
      header: 'Estado',
      type: 'tag',
      severityField: 'estadoBolsa',
      tagSeverityFunction: (rowData: any) => this.getSeverity(rowData.EstadoDescricao),
      tooltip: 'Estado da Solicitação'
    },
    {
      field: 'Data', // caminho que retorna a data
      header: 'Data da Solicitação',
      type: 'date', // ⬅️ novo tipo
      dateFormat: 'dd/MM/yyyy HH:mm', // ⬅️ formate aqui (ex.: 'dd/MM/yyyy HH:mm')
      tooltip: 'Data da Solicitação',
    },
  ];

  ngOnInit(): void {
    this.loadDropdowns();
    this.getAllSolicitacaoRenovacao();
    this.form = this.fb.group({
      InstituicaoEnsinoID: [null],
      InstituicaoGestoraID: [null],
      cursoID: [null],
      nivelAcademicoID: [null],
      EstadoBolsaID: [null],
      Estado: [null],
    });
  }

  getAllSolicitacaoRenovacao(queryParams?: any) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };
    this.solicitacaoRenovacao.list(params).subscribe((response) => {
      this.solicitacaoRenovacaoList = response.data;
      this.solicitacoesCount = response?.totalRecords
        ? response?.totalRecords
        : this.solicitacaoRenovacaoList.length;
      this.pagination = new Pagination<any>().deserialize(response);
    }, (error) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro ao carregar solicitações',
        detail: 'Não foi possível carregar as solicitações de renovação.',
      });
    });
  }

  GotoViewProcess(data: any) {
    if (data?.Id) {
      this.router.navigate([
        '/gestao-bolseiros/renovacao/processo-renovacao',
        data.Id,
      ]);
    } else {
      console.error("ID não encontrado no objeto:", data);
    }
  }



  showDialog() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.showFilter = false;
    this.getAllSolicitacaoRenovacao(filters);
  }

  getSeverity(status: string) {
    switch (status) {
      case 'Pendente':
        return 'warn';
      case 'Aprovado':
        return 'success';
      case 'Rejeitado':
        return 'danger';
      default:
        return 'info';
    }
  }

  loadDropdowns() {
    forkJoin({
      estadoBolsa: this.enumService.getAllEstadoBolsaEnum(),
      nivelAcademico: this.enumService.getAllNivelAcademicoEnum(),
      estadoSolicitacao: this.enumService.getAllEstadoSolicitacaoRenovacaoEnum(),
      instituicoesEnsino: this.instituicaoEnsinoService.list({ pageSize: 100 }),
      instituicoesGEstora: this.instituicaoGestoraService.list({ pageSize: 100 }),
      cursos: this.cursoService.list({ pageSize: 100 }),
    }).subscribe((response) => {
      // Enums
      if (response.estadoSolicitacao?.data) {
        this.estadoSolicitaOptions = Object.entries(response.estadoSolicitacao.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
        this.filters[5].options = this.estadoSolicitaOptions;
      }
      if (response.estadoBolsa?.data) {
        this.estadoBolsaOptions = Object.entries(response.estadoBolsa.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
        this.filters[4].options = this.estadoBolsaOptions;
      }
      if (response.nivelAcademico?.data) {
        this.NivelAcademicoOptions = Object.entries(response.nivelAcademico.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
        this.filters[3].options = this.NivelAcademicoOptions;
      }
      // Listas comuns
      if (response.instituicoesEnsino?.data) {
        this.instituicaoEnsinoList = response.instituicoesEnsino.data.map(
          (item: any) => ({
            label: item.nome,
            value: item.id,
          })
        );
        this.filters[0].options = this.instituicaoEnsinoList;
      }
      if (response.instituicoesGEstora?.data) {
        this.instituicaoGestoraList = response.instituicoesGEstora.data.map(
          (item: any) => ({
            label: item.nome,
            value: item.id,
          })
        );
        this.filters[1].options = this.instituicaoGestoraList;
      }
      if (response.cursos?.data) {
        this.cursoList = response.cursos.data.map((item: any) => ({
          label: item.designacao,
          value: item.id,
        }));
        this.filters[2].options = this.cursoList;
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllSolicitacaoRenovacao();
  }

}
